import { Box, Stack } from "@mui/material";
import { type OtpRequestChannel } from "@src/appV2/Auth/api/useRequestOtp";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface ResendCodeSectionProps {
  isTwilioEnabled: boolean;
  countdownIsLoading: boolean;
  secondsLeft: number;
  onClick: (channel?: OtpRequestChannel) => Promise<void>;
  showContactSupport?: boolean;
  onContactSupport?: () => Promise<void>;
}

export function ResendCodeSection(props: ResendCodeSectionProps) {
  const {
    isTwilioEnabled,
    countdownIsLoading,
    secondsLeft,
    onClick,
    onContactSupport,
    showContactSupport,
  } = props;
  const resendCountdownText = `We resent you a code. You can resend again in ${secondsLeft}s`;
  const didntGetACodeText = "Didn't receive a code? ";

  return (
    <Box sx={{ marginTop: 6, marginBottom: 8 }}>
      {countdownIsLoading ? (
        <Text
          variant="body2"
          sx={{
            textAlign: "center",
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          {resendCountdownText}
        </Text>
      ) : (
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap" justifyContent="center">
          <Text
            variant="body2"
            sx={{
              color: (theme) => theme.palette.text.secondary,
            }}
          >
            {didntGetACodeText}
          </Text>
          <TextButton
            underline
            onClick={async () => {
              if (!isTwilioEnabled) {
                return;
              }

              await onClick("sms");
            }}
          >
            Resend text
          </TextButton>
          {showContactSupport && (
            <>
              <Text
                variant="body2"
                sx={{
                  color: (theme) => theme.palette.text.secondary,
                }}
              >
                or
              </Text>
              <TextButton
                onClick={async () => {
                  await onContactSupport?.();
                }}
              >
                contact support
              </TextButton>
            </>
          )}
        </Stack>
      )}
    </Box>
  );
}
